import { productAxiosInstance } from "@/services/axios";

import { DietaryCategory } from "@/types/product";

export const getAllDietaryCategories = async ({
  productTypeId,
  subTypeId,
  sendThemeCake = false,
}: {
  productTypeId?: number;
  subTypeId?: number;
  sendThemeCake?: boolean;
} = {}): Promise<DietaryCategory[]> => {
  let page = 1;
  let allResults: DietaryCategory[] = [];
  let hasNext = true;
  while (hasNext) {
    const response = await productAxiosInstance.get("/dietary-categories/", {
      params: {
        page,
        product_type_id: productTypeId,
        product_subtype_id: subTypeId,
        send_theme_cakes: sendThemeCake,
      },
    });
    const data = response.data;
    if (Array.isArray(data.results)) {
      allResults = allResults.concat(data.results);
    }
    hasNext = !!data.next;
    page += 1;
  }
  return allResults;
};

export const getProductDetails = async (productSlug: string): Promise<unknown> => {
  try {
    const response = await productAxiosInstance.get(`/products/${productSlug}/`);
    return response.data;
  } catch (error: unknown) {
    const err = error as { response?: { status?: number }; status?: number };
    const statusCode = err?.response?.status ?? err?.status;
    if (statusCode === 404) {
      const notFoundError = new Error("Product not found") as Error & { isNotFound: boolean; status: number };
      notFoundError.isNotFound = true;
      notFoundError.status = 404;
      throw notFoundError;
    }
    throw error;
  }
};
